import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'ULTOSC',
  version: 1,
  label: 'Ultimate Oscillator',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 250,
  inputs: [period('timeperiod1', 7, 'Short length', 1), period('timeperiod2', 14, 'Medium length', 1), period('timeperiod3', 28, 'Long length', 1)],
  outputs: [line('ultosc', 'UO', COLOR.purple)],
  levels: [{ value: 70 }, { value: 30 }],
  talib: {
    functions: ['ULTOSC'],
    expr: 'ULTOSC(high, low, close, timeperiod1={timeperiod1}, timeperiod2={timeperiod2}, timeperiod3={timeperiod3})',
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod1, timeperiod2, timeperiod3 }) => Math.max(timeperiod1, timeperiod2, timeperiod3),
}
export default def
